import React, { useContext, useState } from "react";
import { Table, TableRow, TableBody, TableHead } from "@material-ui/core";

import StyledTableCell, {
  HeadRow,
} from "../../common/styled-table-cell.component";
import { createTableData } from "../../../utils/create-table-data";
import { MatchContext } from "../../../context";
import { SET_HIGHLIGHTED_ROWS } from "../../../reduce/actionTypes";
import { APP_INSIGHTS_EVENTS } from "../../../constants";
import StubCell from "../../common/stub-cell.component";
import useHighlightTableItem from "../../../utils/hooks/use-higlight-table-item";
import useStyles from "../../tables-container/styles";
import prepareRowStyles from "../../../utils/prepare-row-styles";

const EmptyTable = ({
  columnsNumber,
  stockpilesTableFeatures,
}): JSX.Element => {
  const classes = useStyles();
  const { state } = useContext(MatchContext);
  const [hoveredParam, setHoveredParam] = useState("");
  const higlightItem = useHighlightTableItem();

  // fill table rows with data
  const rows = (() => {
    const data: any = [];

    for (let i = 0; i < Object.keys(stockpilesTableFeatures).length; i++) {
      data.push(
        createTableData(Object.values(stockpilesTableFeatures)[i] as string)
      );
    }

    return data;
  })();

  return (
    <Table aria-label="customized table">
      <TableHead>
        <HeadRow>
          <StyledTableCell className={classes.paramCell} align="center">
            Parameter
          </StyledTableCell>
          <StubCell columnsNumber={columnsNumber} />
        </HeadRow>
      </TableHead>
      <TableBody className={state.hideMatchingTable && "hidden"}>
        {rows.map((row) => (
          <TableRow
            key={row.feature}
            className={prepareRowStyles(row, state, hoveredParam, false)}
          >
            <StyledTableCell
              align="center"
              className={classes.dataCell}
              onClick={() =>
                higlightItem(
                  row.feature.toUpperCase(),
                  SET_HIGHLIGHTED_ROWS,
                  "highlightedRows",
                  APP_INSIGHTS_EVENTS.CHANGE_ROW_HIGHLIGHT
                )
              }
              onMouseEnter={() => setHoveredParam(row.feature.toUpperCase())}
              onMouseLeave={() => setHoveredParam("")}
            >
              {row.feature}
            </StyledTableCell>
            <StubCell columnsNumber={columnsNumber} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default EmptyTable;
